import { CSSObject } from "@emotion/react";
import { ToggleButton } from "@newsela/angelou";

import { withTrackEvent } from "@newsela/snitch";
import {
  toggleContainerCss,
  toggleCss,
  toggleDisplayContainerCss,
} from "./AssignmentToggleButton.style";

const ToggleButtonWithTrackEvent = withTrackEvent(
  ToggleButton,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof ToggleButton> &
    React.RefAttributes<HTMLButtonElement>
>;

const AssignmentEmbedToggleButton = ({
  dataProps,
  customCss,
  handleClick,
  isPressed,
  label,
  toggleEventProperties,
}: {
  dataProps: Record<string, unknown>;
  customCss?: CSSObject;
  handleClick: () => void;
  isPressed: boolean;
  label: string;
  toggleEventProperties: Record<string, unknown>;
}) => {
  return (
    <div css={[toggleContainerCss, customCss?.container || {}]}>
      <ToggleButtonWithTrackEvent
        __cssFor={{
          Button: {
            root: [toggleCss, customCss?.["button"] || {}],
          },
        }}
        pressed={isPressed}
        dataProps={dataProps}
        label={label}
        onClick={handleClick}
        {...toggleEventProperties}
      />
      {/**
       * Hide on/off display from assistive technology since it's decorative
       * and the toggle's pressed state will already be announced.
       */}
      <div css={toggleDisplayContainerCss(isPressed)} aria-hidden>
        <span>on</span>
        <span>off</span>
      </div>
    </div>
  );
};

export default AssignmentEmbedToggleButton;
